export const passswordMsg = 'Password should be at least 12 characters including 1 uppercase, 1 lowercase, 1 special character and 1 number.'
export const passwordRegexPattern = /^(?=.*\d)(?=.*[^$*.[{}()?"!@#%&/\\,':;-|_~`+=\]])(?=.*[a-z])(?=.*[A-Z]).{12,}$/
export const nameRegexPattern = /^([^0-9]*)$/
export const phoneNoRegex = /^(08)\d{8}$$/
export const nameErrorMsg = 'Numbers are not permitted'
export const nameWithNoSpecialChar = /^[A-Za-z\s]*$/
export const nameWithNoSpecialCharMsg = `Special Characters and ${nameErrorMsg}`
export const MFA_TYPE = 'SMS_MFA';
export const TYPE_MFA = 'SMS';
export const TYPE_NO_MFA = 'NOMFA'